const SubCategories = t => ({
  Voitures: [
    {
      id: 'InputSelected',
      name: 'bodyType',
      type: 'text',
      placeHolder: t('subCategory.placeholder.bodyType'),
      needTranslate: true,
      data: [
        { value: 'SUV - crossover', label: t('subCategory.SUV - crossover') },
        { value: '4x4 - pick-up', label: t('subCategory.4x4 - pick-up') },
        {
          value: 'Berline - citadine',
          label: t('subCategory.Berline - citadine'),
        },
        { value: 'Monospace', label: t('subCategory.Monospace') },
        {
          value: 'Coupé',
          label: t('subCategory.Coupé'),
        },
        { value: 'Cabriolet', label: t('subCategory.Cabriolet') },
        { value: 'Break', label: t('subCategory.Break') },
        {
          value: 'Fourgon - fourgonette',
          label: t('subCategory.Fourgon - fourgonette'),
        },
        { value: 'Camion - bus', label: t('subCategory.Camion - bus') },
        { value: 'Voiturette', label: t('subCategory.Voiturette') },
      ],
    },
    { id: 'InputBrandCarsComponent', name: 'brand' },
    {
      id: 'InputField',
      name: 'model',
      type: 'text',
      placeHolder: t('subCategory.placeholder.model'),
    },
    {
      id: 'InputField',
      name: 'year',
      type: 'number',
      placeHolder: t('subCategory.placeholder.year'),
    },
    {
      id: 'InputSelected',
      name: 'energy',
      type: 'text',
      placeHolder: t('subCategory.placeholder.energy'),
      needTranslate: true,
      data: [
        { value: 'Essence', label: t('subCategory.Essence') },
        { value: 'Diesel', label: t('subCategory.Diesel') },
        { value: 'GPL', label: t('subCategory.GPL') },
        { value: 'Electrique', label: t('subCategory.Electrique') },
        { value: 'Hybride', label: t('subCategory.Hybride') },
        { value: 'Autre', label: t('subCategory.Autre') },
      ],
    },
    {
      id: 'InputSelected',
      name: 'gearcase',
      type: 'text',
      placeHolder: t('subCategory.placeholder.gearcase'),
      needTranslate: true,
      data: [
        { value: 'Manuelle', label: t('subCategory.Manuelle') },
        { value: 'Automatique', label: t('subCategory.Automatique') },
      ],
    },
    {
      id: 'InputField',
      name: 'km',
      type: 'number',
      placeHolder: t('subCategory.placeholder.km'),
    },
  ],
  Motos: [
    {
      id: 'InputSelected',
      name: 'bodyType',
      type: 'text',
      placeHolder: t('subCategory.placeholder.bodyType'),
      needTranslate: true,
      data: [
        { value: 'Supermotard', label: t('subCategory.Supermotard') },
        { value: 'GT', label: t('subCategory.GT') },
        {
          value: 'Scooter',
          label: t('subCategory.Scooter'),
        },
        { value: 'Trail', label: t('subCategory.Trail') },
        {
          value: 'Enduro',
          label: t('subCategory.Enduro'),
        },
        { value: 'Roadster', label: t('subCategory.Roadster') },
        { value: 'Sportives', label: t('subCategory.Sportives') },
        { value: 'Cross', label: t('subCategory.Cross') },
        { value: 'Custom', label: t('subCategory.Custom') },
        { value: 'Crossover', label: t('subCategory.Crossover') },
      ],
    },
    {
      id: 'InputField',
      name: 'brand',
      type: 'text',
      placeHolder: t('subCategory.placeholder.brand'),
    },
    {
      id: 'InputField',
      name: 'model',
      type: 'text',
      placeHolder: t('subCategory.placeholder.model'),
    },
    {
      id: 'InputField',
      name: 'year',
      type: 'number',
      placeHolder: t('subCategory.placeholder.year'),
    },
    {
      id: 'InputField',
      name: 'km',
      type: 'number',
      placeHolder: t('subCategory.placeholder.km'),
    },
    {
      id: 'InputField',
      name: 'engine',
      type: 'number',
      placeHolder: t('subCategory.placeholder.engine'),
    },
  ],
  Bateaux: [
    {
      id: 'InputSelected',
      name: 'bodyType',
      type: 'text',
      placeHolder: t('subCategory.placeholder.bodyType'),
      needTranslate: true,
      data: [
        { value: 'Motorboat', label: t('subCategory.Motorboat') },
        { value: 'Voilier', label: t('subCategory.Voilier') },
        { value: 'Motor', label: t('subCategory.Motor') },
      ],
    },
    {
      id: 'InputField',
      name: 'brand',
      type: 'text',
      placeHolder: t('subCategory.placeholder.brand'),
    },
    {
      id: 'InputField',
      name: 'year',
      type: 'number',
      placeHolder: t('subCategory.placeholder.year'),
    },
    {
      id: 'InputField',
      name: 'hour_driving',
      type: 'number',
      placeHolder: t('subCategory.placeholder.hour_driving'),
    },
    {
      id: 'InputField',
      name: 'power',
      type: 'number',
      placeHolder: t('subCategory.placeholder.power'),
    },
  ],
  Utilitaires: [
    {
      id: 'InputField',
      name: 'brand',
      type: 'text',
      placeHolder: t('subCategory.placeholder.brand'),
    },
    {
      id: 'InputField',
      name: 'model',
      type: 'text',
      placeHolder: t('subCategory.placeholder.model'),
    },
    {
      id: 'InputField',
      name: 'year',
      type: 'number',
      placeHolder: t('subCategory.placeholder.year'),
    },
    {
      id: 'InputSelected',
      name: 'energy',
      type: 'text',
      placeHolder: t('subCategory.placeholder.energy'),
      needTranslate: true,
      data: [
        { value: 'Essence', label: t('subCategory.Essence') },
        { value: 'Diesel', label: t('subCategory.Diesel') },
        { value: 'GPL', label: t('subCategory.GPL') },
        { value: 'Electrique', label: t('subCategory.Electrique') },
        { value: 'Hybride', label: t('subCategory.Hybride') },
        { value: 'Autre', label: t('subCategory.Autre') },
      ],
    },
    {
      id: 'InputField',
      name: 'km',
      type: 'number',
      placeHolder: t('subCategory.placeholder.km'),
    },
  ],
  Vêtements: [
    {
      id: 'InputSelected',
      name: 'type',
      type: 'text',
      placeHolder: t('subCategory.placeholder.type'),
      needTranslate: true,
      data: [
        { value: 'Femme', label: t('subCategory.Femme') },
        { value: 'Homme', label: t('subCategory.Homme') },
        { value: 'Enfant', label: t('subCategory.Enfant') },
      ],
    },
  ],
  Chaussures: [
    {
      id: 'InputSelected',
      name: 'type',
      type: 'text',
      placeHolder: t('subCategory.placeholder.type'),
      needTranslate: true,
      data: [
        { value: 'Femme', label: t('subCategory.Femme') },
        { value: 'Homme', label: t('subCategory.Homme') },
        { value: 'Enfant', label: t('subCategory.Enfant') },
      ],
    },
    {
      id: 'InputSelected',
      name: 'pointure',
      type: 'number',
      placeHolder: t('subCategory.placeholder.pointure'),
      needTranslate: true,
      data: [
        { value: '20 ou moins', label: t('subCategory.20 ou moins') },
        { value: '21', label: t('subCategory.21') },
        { value: '22', label: t('subCategory.22') },
        { value: '23', label: t('subCategory.23') },
        { value: '24', label: t('subCategory.24') },
        { value: '25', label: t('subCategory.25') },
        { value: '26', label: t('subCategory.26') },
        { value: '27', label: t('subCategory.27') },
        { value: '28', label: t('subCategory.28') },
        { value: '29', label: t('subCategory.29') },
        { value: '30', label: t('subCategory.30') },
        { value: '31', label: t('subCategory.31') },
        { value: '32', label: t('subCategory.32') },
        { value: '33', label: t('subCategory.33') },
        { value: '34', label: t('subCategory.34') },
        { value: '35', label: t('subCategory.35') },
        { value: '36', label: t('subCategory.36') },
        { value: '37', label: t('subCategory.37') },
        { value: '38', label: t('subCategory.38') },
        { value: '39', label: t('subCategory.39') },
        { value: '40', label: t('subCategory.40') },
        { value: '41', label: t('subCategory.41') },
        { value: '42', label: t('subCategory.42') },
        { value: '43', label: t('subCategory.43') },
        { value: '44', label: t('subCategory.44') },
        { value: '45', label: t('subCategory.45') },
        { value: '46', label: t('subCategory.46') },
        { value: '47', label: t('subCategory.47') },
        { value: '48', label: t('subCategory.48') },
        { value: '49', label: t('subCategory.49') },
        { value: '50 ou plus', label: t('subCategory.50 ou plus') },
      ],
    },
  ],
  'Vêtements Bébé': [
    {
      id: 'InputSelected',
      name: 'size',
      type: 'text',
      placeHolder: t('subCategory.placeholder.size'),
      needTranslate: true,
      data: [
        { value: 'Prématuré', label: t('subCategory.Prématuré') },
        { value: '0 mois', label: t('subCategory.0 mois') },
        { value: '1 mois', label: t('subCategory.1 mois') },
        { value: '3 mois', label: t('subCategory.3 mois') },
        { value: '6 mois', label: t('subCategory.6 mois') },
        { value: '9 mois', label: t('subCategory.9 mois') },
        { value: '12 mois', label: t('subCategory.12 mois') },
        { value: '18 mois', label: t('subCategory.18 mois') },
        { value: '24 mois', label: t('subCategory.24 mois') },
        { value: '36 mois', label: t('subCategory.36 mois') },
      ],
    },
  ],
  'Ventes Immobilières': [
    {
      id: 'InputSelected',
      name: 'type',
      type: 'text',
      placeHolder: t('subCategory.placeholder.type'),
      needTranslate: true,
      data: [
        { value: 'Appartement', label: t('subCategory.Appartement') },
        { value: 'Box', label: t('subCategory.Box') },
        {
          value: 'Fonds de commerce',
          label: t('subCategory.Fonds de commerce'),
        },
        { value: 'Immeuble', label: t('subCategory.Immeuble') },
        {
          value: "Immobilier d'entreprise",
          label: t("subCategory.Immobilier d'entreprise"),
        },
        { value: 'Maison', label: t('subCategory.Maison') },
        { value: 'Marina', label: t('subCategory.Marina') },
        { value: 'Parking', label: t('subCategory.Parking') },
        { value: 'Propriété', label: t('subCategory.Propriété') },
        { value: 'Terrain', label: t('subCategory.Terrain') },
        { value: 'Autre', label: t('subCategory.Autre') },
      ],
    },
    {
      id: 'InputSelected',
      name: 'rooms',
      type: 'text',
      placeHolder: t('subCategory.placeholder.rooms'),
      needTranslate: true,
      data: [
        { value: 'Studio', label: t('subCategory.Studio') },
        { value: 'F1', label: t('subCategory.F1') },
        { value: 'F2', label: t('subCategory.F2') },
        { value: 'F3', label: t('subCategory.F3') },
        { value: 'F4', label: t('subCategory.F4') },
        { value: 'F5', label: t('subCategory.F5') },
        { value: '>F5', label: t('subCategory.>F5') },
        { value: 'Bureau', label: t('subCategory.Bureau') },
        { value: 'Dock', label: t('subCategory.Dock') },
        { value: 'Local commercial', label: t('subCategory.Local commercial') },
      ],
    },
    {
      id: 'InputField',
      name: 'surface',
      type: 'number',
      placeHolder: t('subCategory.placeholder.surface'),
    },
  ],
  Locations: [
    {
      id: 'InputSelected',
      name: 'type',
      type: 'text',
      placeHolder: t('subCategory.placeholder.type'),
      needTranslate: true,
      data: [
        { value: 'Appartement', label: t('subCategory.Appartement') },
        { value: 'Box', label: t('subCategory.Box') },
        {
          value: "Immobilier d'entreprise",
          label: t("subCategory.Immobilier d'entreprise"),
        },
        { value: 'Maison', label: t('subCategory.Maison') },
        { value: 'Marina', label: t('subCategory.Marina') },
        { value: 'Parking', label: t('subCategory.Parking') },
        { value: 'Autre', label: t('subCategory.Autre') },
      ],
    },
    {
      id: 'InputSelected',
      name: 'rooms',
      type: 'text',
      placeHolder: t('subCategory.placeholder.rooms'),
      needTranslate: true,
      data: [
        { value: 'Studio', label: t('subCategory.Studio') },
        { value: 'F1', label: t('subCategory.F1') },
        { value: 'F2', label: t('subCategory.F2') },
        { value: 'F3', label: t('subCategory.F3') },
        { value: 'F4', label: t('subCategory.F4') },
        { value: 'F5', label: t('subCategory.F5') },
        { value: '>F5', label: t('subCategory.>F5') },
        { value: 'Bureau', label: t('subCategory.Bureau') },
        { value: 'Dock', label: t('subCategory.Dock') },
        { value: 'Local commercial', label: t('subCategory.Local commercial') },
      ],
    },
    {
      id: 'InputField',
      name: 'surface',
      type: 'number',
      placeHolder: t('subCategory.placeholder.surface'),
    },
    {
      id: 'InputSelected',
      name: 'meuble_not_meuble',
      type: 'text',
      placeHolder: t('Meublé / Non meublé'),
      needTranslate: true,
      data: [
        { value: 'Meublé', label: t('subCategory.Meublé') },
        { value: 'Non meublé', label: t('subCategory.Non meublé') },
      ],
    },
  ],
  Animaux: [
    {
      id: 'InputSelected',
      name: 'type',
      type: 'text',
      placeHolder: t('subCategory.placeholder.type'),
      needTranslate: true,
      data: [
        { value: 'Chats', label: t('subCategory.Chats') },
        { value: 'Chiens', label: t('subCategory.Chiens') },
        { value: 'Autres animaux', label: t('subCategory.Autres animaux') },
        { value: 'Accessoire', label: t('subCategory.Accessoire') },
      ],
    },
  ],
  "Offres d'emploi": [
    {
      id: 'InputSelected',
      name: 'type',
      type: 'text',
      placeHolder: t('subCategory.placeholder.type_contract'),
      needTranslate: true,
      data: [
        { value: 'CDD', label: t('subCategory.CDD') },
        { value: 'CDI', label: t('subCategory.CDI') },
        { value: 'Interim', label: t('subCategory.Interim') },
        { value: 'Stage/Alternance', label: t('subCategory.Stage/Alternance') },
        { value: 'Autre', label: t('subCategory.Autre') },
      ],
    },
    {
      id: 'InputSelected',
      name: 'job',
      type: 'text',
      placeHolder: t('subCategory.placeholder.job'),
      needTranslate: true,
      data: [
        {
          value: 'Administration/Services généraux',
          label: t('subCategory.Administration/Services généraux'),
        },
        { value: 'Commercial/Vente', label: t('subCategory.Commercial/Vente') },
        {
          value: 'Comptabilité/Gestion/Finance',
          label: t('subCategory.Comptabilité/Gestion/Finance'),
        },
        { value: 'Conseil/Audit', label: t('subCategory.Conseil/Audit') },
        {
          value: 'Direction Générale',
          label: t('subCategory.Direction Générale'),
        },
        {
          value: 'Etudes/Recherches/Ingénieries',
          label: t('subCategory.Etudes/Recherches/Ingénieries'),
        },
        {
          value: 'Formation/Education',
          label: t('subCategory.Formation/Education'),
        },
        {
          value: 'Hôtellerie/Restauration',
          label: t('subCategory.Hôtellerie/Restauration'),
        },
        {
          value: 'Informatique/Internet',
          label: t('subCategory.Informatique/Internet'),
        },
        { value: 'Juridique', label: t('subCategory.Juridique') },
        {
          value: 'Logistique/Achat/Transport',
          label: t('subCategory.Logistique/Achat/Transport'),
        },
        {
          value: 'Marketing/Communication',
          label: t('subCategory.Marketing/Communication'),
        },
        { value: 'Ménage/Entretien', label: t('subCategory.Ménage/Entretien') },
        { value: 'Médecine/Santé', label: t('subCategory.Médecine/Santé') },
        { value: 'Ouvrier/Artisan', label: t('subCategory.Ouvrier/Artisan') },
        {
          value: 'Production/Opérations',
          label: t('subCategory.Production/Opérations'),
        },
        {
          value: 'Ressources Humaines/Formation',
          label: t('subCategory.Ressources Humaines/Formation'),
        },
        {
          value: 'Sécurité/Défense/Gardiennage',
          label: t('subCategory.Sécurité/Défense/Gardiennage'),
        },
        {
          value: 'Services à la personne',
          label: t('subCategory.Services à la personne'),
        },
        {
          value: 'Service Client/Accueil',
          label: t('subCategory.Service Client/Accueil'),
        },
        { value: 'Autre', label: t('subCategory.Autre') },
      ],
    },
    {
      id: 'InputSelected',
      name: 'experience',
      type: 'text',
      placeHolder: t('subCategory.placeholder.experience'),
      needTranslate: true,
      data: [
        { value: '0 à 2 ans', label: t('subCategory.0 à 2 ans') },
        { value: '2 à 5 ans', label: t('subCategory.2 à 5 ans') },
        { value: '5 à 10 ans', label: t('subCategory.5 à 10 ans') },
        { value: '10 ans et plus', label: t('subCategory.10 ans et plus') },
      ],
    },
  ],
});

export default SubCategories;
